import {LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS} from "../types/tipoSeguroObservacionActionTypes";
import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

export function loadTiposSeguroObservacion() {
    return function (dispatch) {
        return apiSource.obtener<ICatalogo[]>("tipo-seguro-observacion/many")
            .then((tiposSeguroObservacion: ICatalogo[]) => {
                dispatch({type: LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS, tiposSeguroObservacion})
            })
            .catch(error => {
                //throw error;
            })
    }
}
